import { useUploadResultDialogStore } from '@/state/uploadResultDialogStore';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

export function UploadResultDialog() {
  const open = useUploadResultDialogStore((state) => state.open);
  const outcome = useUploadResultDialogStore((state) => state.outcome);
  const title = useUploadResultDialogStore((state) => state.title);
  const message = useUploadResultDialogStore((state) => state.message);
  const close = useUploadResultDialogStore((state) => state.close);

  const isSuccess = outcome === 'success';

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
          {isSuccess ? (
            <CheckCircleOutlineIcon color="success" sx={{ mt: 0.25 }} />
          ) : (
            <ErrorOutlineIcon color="error" sx={{ mt: 0.25 }} />
          )}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
          >
            {message}
          </Typography>
        </Box>
        {!isSuccess ? (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
            See the Messages panel for full details.
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" onClick={close} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
